import { useEffect, useState } from "react";
import { scrollToEdge } from "../../lib/scroll";

export function ScrollControls() {
  const [edge, setEdge] = useState({ top: true, bottom: false });
  useEffect(() => {
    let frame = 0;
    const measure = () => {
      setEdge({
        top: window.scrollY < 4,
        bottom:
          window.scrollY + window.innerHeight >=
          document.documentElement.scrollHeight - 4,
      });
      frame = 0;
    };
    const update = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    const resize = new ResizeObserver(update);
    resize.observe(document.body);
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    measure();
    return () => {
      resize.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  return (
    <div className="scroll-controls" role="group" aria-label="Page shortcuts">
      <button
        type="button"
        aria-label="Go to page top"
        disabled={edge.top}
        onClick={() => scrollToEdge("top")}
        title="Go to page top"
      >
        ↑
      </button>
      <button
        type="button"
        aria-label="Go to page bottom"
        disabled={edge.bottom}
        onClick={() => scrollToEdge("bottom")}
        title="Go to page bottom"
      >
        ↓
      </button>
    </div>
  );
}
